import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Section from '../ui/Section';
import Button from '../ui/Button';
import { Reveal } from '../ui/Reveal';

const CtaSection = () => {
  const navigate = useNavigate();

  return (
    <Section className="bg-surface">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-700 via-brand-800 to-slate-900 px-8 py-14 text-center sm:px-14 sm:py-16">
          <div className="absolute inset-0 -z-0 bg-grid-slate opacity-40" aria-hidden="true" />
          <div
            className="absolute -right-10 -top-16 -z-0 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl"
            aria-hidden="true"
          />

          <div className="relative">
            <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Ready to build smarter infrastructure?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-lg text-brand-100">
              Let's design a solution sized to your workloads, timeline, and budget — with
              hardware and support you can rely on.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button variant="white" size="lg" onClick={() => navigate('/contact')}>
                Schedule a Consultation
                <ArrowRight className="h-5 w-5" aria-hidden="true" />
              </Button>
              <Button variant="secondary" size="lg" onClick={() => navigate('/products')}>
                Explore Solutions
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </Section>
  );
};

export default CtaSection;
